
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { OrganizationService } from '../../shared/services/organization.service';
import { StaticValueService } from '../../shared/services/static-value.service';
import { AuthService } from '../../shared/services/auth/auth.service';
import { MatSnackBar, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DeletePopupComponent } from '../Popups/delete-popup/delete-popup.component';
import { ToastService } from '../../shared/services/toast.service';
import { Sort, PageEvent } from '@angular/material';
import { MobileFilterComponent } from '../../shared/components/mobile-filter/mobile-filter.component';
import { Router } from '@angular/router';
import { Configuration } from '../../app.constants';
import { IonicAngular4CacheService } from 'ionic-angular4-cache';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.css'],
    providers: [OrganizationService]
})
export class ListComponent implements OnInit, OnDestroy {
    public serverApiUrl;
    public isLoading: Boolean = false;
    // select All variables
    public selectAll: Boolean = false;
    public numberOfSelectedOrganizations = 0;
    public numberOfAllSelectedOrganizations = 0;
    public bulkOperationOrganizations = {};
    public distinctOpcoCountries = [];
    // -------
    public stats = {};
    public organizations = [];
    public nameSearch = '';
    public country: string;
    public dropDowns: any;
    public search: any;
    public query: any;
    public currentUserId: string;
    public isAdmin: Boolean = false;
    public errors: any;
    public pageIndex = 1;
    public searchNameBeh = new BehaviorSubject<string>('');
    public searchNameObs = this.searchNameBeh.asObservable();
    public obserablesArr = [];

    public p: Number = 1;
    public length = 100;
    public pageSize = 10;
    public pageSizeOptions = [5, 10, 25, 100];
    ngOnDestroy() {
        this.obserablesArr.forEach(element => {
            element.unsubscribe();
        });
    }

    constructor(
        public _router: Router,
        public dialog: MatDialog,
        public mobileNav: MobileNavService,
        public organizationService: OrganizationService,
        public staticService: StaticValueService,
        public authService: AuthService,
        public toastService: ToastService,
        public config: Configuration,
        public ionicAngular4Cache: IonicAngular4CacheService) { }

    ngOnInit() {
        this.search = {
            name: '',
            country: '',
            city: '',
            archived: false
        };
        this.obserablesArr.push(this.searchNameObs.pipe(debounceTime(700)).subscribe(value => {
            this.onChange();
        }));
        this.serverApiUrl = this.config.StaticImageUrl;
        this.currentUserId = this.authService.user.associateId;
        if (this.authService.user.role === 'Admin') {
            this.isAdmin = true;
        }
        this.dropDowns = this.staticService.staticData['staticDD'];
        this.organizationService.getOpcoCountries().subscribe(data => {
            this.distinctOpcoCountries = Object.assign([], data);
        }, error => { });
        this.errors = this.staticService.errors;
        this.query = {
            search: {
                'active': true,
                'company.companyName': { $regex: '', $options: 'i' },
                'company.cityOfReference': { $regex: '', $options: 'i' },
                // 'team': ''
            },
            sort: { 'company.companyName': 1 },
            pagination: {
                pageIndex: 0,
                pageSize: this.pageSize
            }
        };

        // this.getOrganizationFromService();
    }

    nameSearched() {
        this.searchNameBeh.next(this.search.name);
    }

    onClickMe() {
        this.mobileNav.showSideNav();
    }
    onChange() {
        // to disable the selectAll checkbox
        this.selectAll = false;
        this.numberOfSelectedOrganizations = 0;
        if (this.isAdmin) {
            if (this.search.archived === true) {
                let tempSearch = {
                    'active': false,
                    'company.companyName': { $regex: '', $options: 'i' },
                    'company.countryOfReference': '',
                    'company.cityOfReference': { $regex: '', $options: 'i' },
                    // 'team': ''
                };
                this.query.search = Object.assign({}, tempSearch);

            } else if (this.search.archived === false) {
                let tempSearch = {
                    'active': true,
                    'company.companyName': { $regex: '', $options: 'i' },
                    'company.countryOfReference': '',
                    'company.cityOfReference': { $regex: '', $options: 'i' },
                    // 'team': ''
                };
                this.query.search = Object.assign({}, tempSearch);
            }
        }
        this.query.search['company.companyName'] = { $regex: this.search.name, $options: 'i' };
        this.query.search['company.countryOfReference'] = this.search.country;
        this.query.search['company.cityOfReference'] = { $regex: this.search.city, $options: 'i' };
        this.getOrganizationFromService();
    }

    getServerData(event) {
        this.query.pagination.pageIndex = event.pageIndex;
        this.query.pagination.pageSize = event.pageSize;
        this.getOrganizationFromService();
    }

    setPageSizeOptions(setPageSizeOptionsInput: string) {
        this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
    }

    sortData(sort: Sort) {
        this.query.sort = {};
        if (sort.direction === 'asc') {
            this.query.sort[sort.active] = -1;
        } else if (sort.direction === 'desc') {
            this.query.sort[sort.active] = 1;
        }
        this.getOrganizationFromService();
    }
    getOrganizationsFromCache() {
        console.log('call get organization function');
        this.ionicAngular4Cache.getItemOld('organizationSearch').then((data) => {
            if (data) {
                console.log('get data from cache');
                this.organizations = data['data']
                this.length = data['numberOfSelectedOrganizations'];
            }
        }).catch((error) => {
        });
    }

    getOrganizationFromService() {
        console.log('get organizations from service');
        this.isLoading = true;
        this.organizationService.search(
            this.query.pagination.pageIndex,
            this.query.pagination.pageSize,
            this.query.search,
            this.query.sort)
            .then((data) => {
                this.isLoading = false;
                this.stats = data['stats'];
                this.numberOfAllSelectedOrganizations = data['numberOfSelectedOrganizations'];
                this.organizations = data['data'];
                this.length = this.numberOfAllSelectedOrganizations;
            }, (err) => {
                this.isLoading = false;
                this.getOrganizationsFromCache();
            });
    }

    // get organizations for mobile
    getOrganizationsMobile(pageIndex) {
        this.getOrganizationMobileFromService(pageIndex);
    }

    getOrganizationMobileFromService(pI) {
        this.isLoading = true;
        this.organizationService.search(
            pI,
            this.query.pagination.pageSize,
            this.query.search,
            this.query.sort)
            .then((data) => {
                this.isLoading = false;
                this.stats = data['stats'];
                this.numberOfAllSelectedOrganizations = data['numberOfSelectedOrganizations'];
                this.organizations = this.organizations.concat(data['data']);
                this.length = this.numberOfAllSelectedOrganizations;
                this.pageIndex = this.pageIndex + 1;
            }, (err) => {
                this.isLoading = false;
                console.log(err);
            });
    }

    multiSelectChange(event, orgId) {
        if (event.target.checked === true) {
            this.bulkOperationOrganizations[orgId] = orgId;
        } else if (orgId in this.bulkOperationOrganizations) {
            delete this.bulkOperationOrganizations[orgId];
        }
        this.selectedOrganizationsNumber();
    }
    // open dialog for bulk archive
    openDialog(): void {
        const dialogRef = this.dialog.open(DeletePopupComponent, {
            width: '400px',
            data: { name: 'Organizations', length: this.numberOfSelectedOrganizations }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'Cancel') {
            } else if (result === 'Proceed') {
                this.bulkArchive();
            }
        });
    }

    bulkArchive() {
        if (!this.selectAll) {
            this.organizationService.bulkArchive(this.bulkOperationOrganizations).subscribe((data) => {
                this.getOrganizationFromService();
                this.numberOfSelectedOrganizations = 0;
                this.bulkOperationOrganizations = Object.assign({}, {});
                this.toastService.success();
            }, (error) => {
                this.toastService.error(this.errors.Server['501']);
            });
        } else {
            this.organizationService.bulkArchive(this.bulkOperationOrganizations, this.query).subscribe((data) => {
                // reset filters @todo
                this.getOrganizationFromService();
                this.numberOfSelectedOrganizations = 0;
                this.bulkOperationOrganizations = Object.assign({}, {});
                this.toastService.success();
            }, (error) => {
                this.toastService.error(this.errors.Server['501']);
            });
        }
    }

    // check whether organization is in bulkOperations hash
    existsInBulkOperations(orgId) {
        return orgId in this.bulkOperationOrganizations;
    }
    // length of selected Organizations
    selectedOrganizationsNumber() {
        this.numberOfSelectedOrganizations = Object.keys(this.bulkOperationOrganizations).length;
    }
    // select All organizations
    selectAllChange(event) {
        this.selectAll = event.target.checked;
        if (event.target.checked === true) {
            this.numberOfSelectedOrganizations = this.numberOfAllSelectedOrganizations;
        } else if (event.target.checked === false) {
            this.numberOfSelectedOrganizations = 0;
            this.bulkOperationOrganizations = Object.assign({}, {});
        }
    }
    onClickFilter() {
        let dialogRef = this.dialog.open(MobileFilterComponent, {
            width: '300px',
            data: { type: 'company', city: this.search.city, country: this.search.country }
        });

        dialogRef.afterClosed().subscribe(res => {
            if (res !== undefined) {
                this.search.city = res.city;
                this.search.country = res.country;
                this.onChange()
            }
        });
    }

    @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
        if (window.innerWidth < 768) {
            let h = document.documentElement,
                b = document.body,
                st = 'scrollTop',
                sh = 'scrollHeight';
            var percent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;
            if (percent === 100) {
                this.getOrganizationsMobile(this.pageIndex);
            }
        }
    }

    mobileRouting(url, id) {
        if (window.innerWidth < 600) {
            this._router.navigate([url, id]);
        }
    }

}
